export enum TestTypes {
  CRLCovidClearAntibody = "CRL Covid Clear - Antibody",
  CRLRapidResponseCovid = "CRL Rapid Response - Covid"
}
